// File: src/components/common/StyledMediaContainer.js
// -----------------------------------------------------
import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Styled media container component
 */
const StyledMediaContainer = ({ children, height = 160, ...props }) => (
  <Box 
    sx={{ 
      position: 'relative',
      ...props.sx
    }}
    {...props}
  >
    <Box sx={{ 
      height: height, 
      overflow: 'hidden',
    }}>
      {children}
    </Box>
  </Box>
);

StyledMediaContainer.propTypes = {
  children: PropTypes.node,
  height: PropTypes.number,
  sx: PropTypes.object
};

export default StyledMediaContainer;